var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g, _path28, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgBadRobot = function SvgBadRobot(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 362,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.366 329.61C149.912 331.462 132.179 336.297 126.619 338.483C91.5479 345.946 129.625 357.77 137.14 357.77H173.213C194.757 357.77 186.74 356.227 245.86 361.242C293.156 365.254 311.66 352.37 315 345.426C313.831 341.054 307.284 332.311 290.45 332.311C269.408 332.311 209.433 327.296 176.366 329.61Z",
    fill: "#C3C3C7",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.652 142.089H173.774C162.142 142.089 152.747 132.682 152.747 121.036V111.181C152.747 99.5353 162.142 90.1288 173.774 90.1288H256.652C268.284 90.1288 277.679 99.5353 277.679 111.181V121.036C277.679 132.682 268.284 142.089 256.652 142.089Z",
    fill: "#C0DAF1",
    stroke: "#0076BB",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M261.685 100.879C262.021 101.103 262.356 101.327 262.692 101.439C265.488 103.231 267.949 105.022 267.949 111.517V121.148C267.949 127.531 262.692 132.794 256.317 132.794H214.486C212.473 132.794 211.243 130.778 212.026 128.987C213.48 125.851 216.164 121.036 221.421 115.661C231.04 106.03 239.428 100.207 251.843 98.8635C255.198 98.5275 258.665 99.3114 261.685 100.879Z",
    fill: "#E5EFF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222.092 94.0482H171.873C166.057 94.0482 155.432 100.879 156.774 113.421V122.94C157.557 130.554 165.386 138.281 173.327 138.281H179.255C179.255 138.281 185.63 94.0482 222.092 94.0482Z",
    fill: "#7CB7E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.915 164.709H189.209C187.643 164.709 186.413 163.477 186.413 161.909V144.888C186.413 143.32 187.643 142.089 189.209 142.089H245.915C247.481 142.089 248.711 143.32 248.711 144.888V161.909C248.711 163.477 247.481 164.709 245.915 164.709Z",
    fill: "#C0DAF1",
    stroke: "#0076BB",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M230.257 164.709H204.196V283.074H230.257V164.709Z",
    fill: "#7CB7E4",
    stroke: "#0076BB",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.372 232.57L167.735 282.178C170.531 288.673 176.682 293.264 183.617 293.712C183.952 293.712 184.4 293.712 184.735 293.712H250.389C252.29 293.712 254.192 293.488 255.981 292.928C261.126 291.361 265.264 287.441 267.501 282.514L289.423 232.682L292.219 227.195C295.463 220.588 290.653 212.413 282.936 212.525H152.747C149.839 212.525 147.602 213.981 145.589 215.549C140.109 219.468 145.589 230.778 146.372 232.57Z",
    fill: "#C0DAF1",
    stroke: "#0076BB",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M199.611 115.549C199.611 123.052 194.801 130.666 185.071 130.666C175.899 130.666 169.86 122.492 170.754 113.645C172.544 95.504 199.611 97.0717 199.611 115.549Z",
    fill: "#0076BB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M184.956 113.499C186.186 111.719 185.906 109.391 184.331 108.301C182.757 107.21 180.483 107.77 179.253 109.55C178.024 111.33 178.303 113.657 179.878 114.748C181.453 115.838 183.726 115.279 184.956 113.499Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M256.54 115.549C256.54 123.052 251.731 130.666 242 130.666C232.829 130.666 226.789 122.492 227.684 113.645C229.474 95.504 256.54 97.0717 256.54 115.549Z",
    fill: "#0076BB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M241.884 113.502C243.113 111.722 242.834 109.395 241.259 108.304C239.684 107.214 237.41 107.773 236.181 109.553C234.951 111.333 235.231 113.66 236.806 114.751C238.38 115.841 240.654 115.282 241.884 113.502Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165.498 341.081C178.408 341.081 188.874 330.602 188.874 317.676C188.874 304.751 178.408 294.272 165.498 294.272C152.588 294.272 142.122 304.751 142.122 317.676C142.122 330.602 152.588 341.081 165.498 341.081Z",
    fill: "#AFB2D8",
    stroke: "#0076BB",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M165.498 324.955C169.822 324.955 173.327 321.446 173.327 317.116C173.327 312.787 169.822 309.278 165.498 309.278C161.174 309.278 157.668 312.787 157.668 317.116C157.668 321.446 161.174 324.955 165.498 324.955Z",
    fill: "white",
    stroke: "#0076BB",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M216.611 341.081C229.521 341.081 239.987 330.602 239.987 317.676C239.987 304.751 229.521 294.272 216.611 294.272C203.701 294.272 193.236 304.751 193.236 317.676C193.236 330.602 203.701 341.081 216.611 341.081Z",
    fill: "#AFB2D8",
    stroke: "#0076BB",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M216.611 324.955C220.935 324.955 224.441 321.446 224.441 317.116C224.441 312.787 220.935 309.278 216.611 309.278C212.287 309.278 208.782 312.787 208.782 317.116C208.782 321.446 212.287 324.955 216.611 324.955Z",
    fill: "white",
    stroke: "#0076BB",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M269.067 341.081C281.977 341.081 292.443 330.602 292.443 317.676C292.443 304.751 281.977 294.272 269.067 294.272C256.157 294.272 245.691 304.751 245.691 317.676C245.691 330.602 256.157 341.081 269.067 341.081Z",
    fill: "#AFB2D8",
    stroke: "#0076BB",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M269.179 324.955C273.503 324.955 277.008 321.446 277.008 317.116C277.008 312.787 273.503 309.278 269.179 309.278C264.855 309.278 261.35 312.787 261.35 317.116C261.35 321.446 264.855 324.955 269.179 324.955Z",
    fill: "white",
    stroke: "#0076BB",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M280.587 197.296L277.008 185.874",
    stroke: "#EADB9E",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M309.22 212.301L320.293 207.15",
    stroke: "#EADB9E",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M297.364 199.871L303.068 189.121",
    stroke: "#EADB9E",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M208.111 191.585C208.111 173.779 215.269 172.772 226.454 173.22V168.516L208.111 168.628",
    fill: "#7CB7E4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M190.439 146.12L244.461 145.896V151.495C244.461 151.495 203.19 146.008 197.933 160.902H190.439V146.12Z",
    fill: "#7CB7E4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M185.071 289.681L171.985 250.151C169.524 238.505 176.459 230.666 187.979 227.307C195.696 225.067 239.204 225.179 248.823 224.059C258.442 222.94 262.916 220.476 271.751 216.333H152.3C148.273 216.333 145.589 220.476 147.155 224.171L170.307 278.259C171.202 280.386 172.32 282.626 173.662 284.53C176.011 287.777 179.814 289.681 183.729 289.681H185.071Z",
    fill: "#7CB7E4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M224.552 282.85H248.823C251.507 282.85 253.968 281.282 255.198 278.819L266.495 254.967C267.278 253.287 265.935 251.495 264.146 251.607C254.639 252.615 231.04 257.206 222.427 279.603C221.868 281.17 222.875 282.85 224.552 282.85Z",
    fill: "#E5EFF9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M265.041 237.497L270.297 227.307C271.08 225.851 272.534 224.955 274.1 224.955C277.12 224.955 279.245 228.091 278.015 230.89L273.877 241.305C273.094 243.096 271.192 244.216 269.291 243.88L268.172 243.656C265.376 243.208 263.81 240.073 265.041 237.497Z",
    fill: "#E5EFF9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M214.598 90.1289L215.717 50.5992",
    stroke: "#0076BB",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M215.269 69.3002C221.199 69.3002 226.006 64.7378 226.006 59.1098C226.006 53.4818 221.199 48.9194 215.269 48.9194C209.339 48.9194 204.532 53.4818 204.532 59.1098C204.532 64.7378 209.339 69.3002 215.269 69.3002Z",
    fill: "#EFE1AA",
    stroke: "#0076BB",
    strokeWidth: 7,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M231.048 38.1839C222.066 29.2018 207.186 29.5184 197.814 38.891",
    stroke: "#C7C9E2",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M242.362 26.8701C227.522 12.0301 202.828 12.6633 187.207 28.2843",
    stroke: "#C7C9E2",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1:1296)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-30-inside-1_1:1296",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7073 123C24.3184 123 16.7073 130.611 16.7073 140V195C16.7073 204.389 24.3184 212 33.7073 212H104.215C113.604 212 121.215 204.389 121.215 195V182.946L140.213 162.016C141.963 160.089 140.595 157 137.992 157H121.215V140C121.215 130.611 113.604 123 104.215 123H33.7073Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7073 123C24.3184 123 16.7073 130.611 16.7073 140V195C16.7073 204.389 24.3184 212 33.7073 212H104.215C113.604 212 121.215 204.389 121.215 195V182.946L140.213 162.016C141.963 160.089 140.595 157 137.992 157H121.215V140C121.215 130.611 113.604 123 104.215 123H33.7073Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.215 182.946L116.032 178.241L114.215 180.243V182.946H121.215ZM140.213 162.016L135.03 157.312L140.213 162.016ZM121.215 157H114.215V164H121.215V157ZM23.7073 140C23.7073 134.477 28.1844 130 33.7073 130V116C20.4524 116 9.70728 126.745 9.70728 140H23.7073ZM23.7073 195V140H9.70728V195H23.7073ZM33.7073 205C28.1844 205 23.7073 200.523 23.7073 195H9.70728C9.70728 208.255 20.4524 219 33.7073 219V205ZM104.215 205H33.7073V219H104.215V205ZM114.215 195C114.215 200.523 109.738 205 104.215 205V219C117.47 219 128.215 208.255 128.215 195H114.215ZM114.215 182.946V195H128.215V182.946H114.215ZM126.398 187.651L145.396 166.721L135.03 157.312L116.032 178.241L126.398 187.651ZM145.396 166.721C151.229 160.296 146.669 150 137.992 150V164C134.521 164 132.697 159.882 135.03 157.312L145.396 166.721ZM137.992 150H121.215V164H137.992V150ZM114.215 140V157H128.215V140H114.215ZM104.215 130C109.738 130 114.215 134.477 114.215 140H128.215C128.215 126.745 117.47 116 104.215 116V130ZM33.7073 130H104.215V116H33.7073V130Z",
    fill: "#0076BB",
    mask: "url(#path-30-inside-1_1:1296)"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8885 175.48C58.2085 175.48 59.8885 173.64 59.8885 171.32C59.8885 169 58.2085 167.16 55.8885 167.16C53.5685 167.16 51.8885 169 51.8885 171.32C51.8885 173.64 53.5685 175.48 55.8885 175.48ZM68.701 175.48C71.021 175.48 72.701 173.64 72.701 171.32C72.701 169 71.021 167.16 68.701 167.16C66.381 167.16 64.701 169 64.701 171.32C64.701 173.64 66.381 175.48 68.701 175.48ZM81.5135 175.48C83.8335 175.48 85.5135 173.64 85.5135 171.32C85.5135 169 83.8335 167.16 81.5135 167.16C79.1935 167.16 77.5135 169 77.5135 171.32C77.5135 173.64 79.1935 175.48 81.5135 175.48Z",
    fill: "#0076BB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1:1296",
    x: 0.707275,
    y: 111,
    width: 156.29,
    height: 121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1:1296"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1:1296",
    result: "shape"
  })))));
};
export { SvgBadRobot as ReactComponent };
export default __webpack_public_path__ + "static/media/bad-robot.56007967.svg";